let cardNumber = document.querySelectorAll('.product-highlights__card');
if(!cardNumber.length) return;

const Flickity = themeVendor.Flickity;
function calculateAndIinitSliders() {
  var r = document.querySelector(':root');
  let desktopWidth = document.querySelector('.hidden-sm .section-columns__wrapper').getBoundingClientRect().width
  let mobileWidth = document.querySelector('.mobile-only .section-columns__wrapper').getBoundingClientRect().width
  r.style.setProperty('--desktopHighlightWidth', desktopWidth + "px");
  r.style.setProperty('--mobileHighlightWidth', mobileWidth + "px");

  const highlights= document.querySelectorAll('.section-columns__slider');
  highlights.forEach(highlight => {
    let flktyHighlight = new Flickity(highlight, {
      wrapAround: true,
      pageDots: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      cellAlign: 'left'
    });
  });
}

window.addEventListener('DOMContentLoaded', function(){
  calculateAndIinitSliders();
});


window.addEventListener('resize', function(){
  calculateAndIinitSliders();
});
